import {REFERRAL_ACCOUNT_BALANCE, CLEAR_REFERRAL_INFO, COMING_FROM_REFERRAL, REFERRAL_ADDITIONAL_DETAILS, REFERRAL_FOR, REFERRAL_INCLUSION_TEAM, REFERRAL_OTHER_DETAILS,
   REFERRAl_REASON, COMING_FROM_CASE, WO_REDIRECT_FROM_EMAIL, ASSET_BACK_COUNTER, ASSET_ARRAY, RELEASE_ASSET_ARRAY, REMOVE_ASSET_ARRAY,
    FINISH_JOURNEY, SERVICE_CARD_DATA, GAS_CARD_DATA, PREVIOUS_PAGE, COMING_FROM_CASE_LIST, DMC_DATA, DMC_ANS_DATA, 
    REMOVE_DMC_DATA,
    STORE_SORDAMP,
    SEARCH_TYPE_SORT_DATA_REMOVE,
  SEARCH_TYPE_ASSIGN_TO_ME_DATA_REMOVE,
  SEARCH_TYPE_SORT_DATA,
  SEARCH_TYPE_SERVICE_REQUEST_REMOVE,
  SEARCH_TYPE_SERVICE_REQUEST,
  SEARCH_TYPE_WORKORDER_REMOVE,
  SEARCH_TYPE_WORKORDER,
  SEARCH_TYPE_PROPERTY_REMOVE,
  SEARCH_TYPE_PROPERTY,
  SEARCH_TYPE_CUSTOMER_REMOVE,
  SEARCH_TYPE_CUSTOMER,
  SEARCH_TYPE_ASSIGN_TO_ME_DATA,
  API_ERRORS, 
  DUPLICATE_DMC_ANS_DATA,
  REFERRAL_DEBT_TYPES,
  REFERRAL_REASON_REFERENCE_DATA,
  REFERRAL_NOSP_DETAILS,
  NOSP_REFERENCE_DATA,
  SAVE_NOSP_DETAILS_PAYLOAD,
  IS_HHSRS_ENABLED,
  HHSRS_OPTION,
  HAZARD_TYPE,
  SAVERITY_SCORE,
  ASSET_SUBTYPE,
  PARENT_ASSET_TYPE
  } from "../actionTypes";

  
// HHSRS Actions
export const saveHHSRSOption = (data: any): any => {
  return { type: HHSRS_OPTION, payload: data };
};

export const saveHazardType = (data: any): any => {
  return { type: HAZARD_TYPE, payload: data };
};

export const saveSaverityScore = (data: any): any => {
  return { type: SAVERITY_SCORE, payload: data };
};
export const financialReferralFor = (financialReferral: string): any => {
  return { type: REFERRAL_FOR, payload: financialReferral };
};

export const FinancialReferralReasonRes = (referralReason: any[]): any => {
  return { type: REFERRAl_REASON, payload: referralReason };
};

export const FinancialInclusionTeam = (inclusionTeam: boolean): any => {
  return { type: REFERRAL_INCLUSION_TEAM, payload: inclusionTeam };
};

export const FinancialOtherDetails = (otherDetails: string): any => {
  return { type: REFERRAL_OTHER_DETAILS, payload: otherDetails };
};

export const clearReferralInformation = (data: any): any => {
  return { type: CLEAR_REFERRAL_INFO, payload: data };
};

export const comingFromReferralPage = (data: boolean): any => {
  return { type: COMING_FROM_REFERRAL, payload: data };
};

export const storeReferralAdditionalDetails = (data: any): any => {
  return { type: REFERRAL_ADDITIONAL_DETAILS, payload: data };
};

export const saveReferralAccountBalance = (data: string): any => {
  return { type: REFERRAL_ACCOUNT_BALANCE, payload: data };
};

export const comingFromCase = (data: boolean): any => {
  return { type: COMING_FROM_CASE, payload: data };
};

export const assetBackCouterDispatch = (data: number): any => {
  return { type: ASSET_BACK_COUNTER, payload: data };
};

export const assetArrayDispatch = (data: any): any => {
  return { type: ASSET_ARRAY, payload: data };
};

export const releaseAssetArrayDispatch = (data: any): any => {
  return { type: RELEASE_ASSET_ARRAY, payload: data };
};

export const removeAssetArrayDispatch = (data: any): any => {
  return { type: REMOVE_ASSET_ARRAY, payload: data };
};

export const woRedirectFromEmailStatus = (data: boolean): any => {
  return { type: WO_REDIRECT_FROM_EMAIL, payload: data };
};

export const finishJourney = (data: boolean): any => {
  return { type: FINISH_JOURNEY, payload: data };
};

export const comingFromCaseListData = (data: any): any => {
  return { type: COMING_FROM_CASE_LIST, payload: data };
};
export const savingServiceCardData = (data:any):any => {
  return {type:SERVICE_CARD_DATA, payload:data}
}
export const gasBoilderData = (data:any):any => {
  return {type:GAS_CARD_DATA, payload:data}
}

export const getPreviousPageName = (data:string):any => {
  return {type:PREVIOUS_PAGE, payload:data}
}


export const saveDMCQuestions = (data:any):any => {
  return {type:DMC_DATA, payload:data}
}

export const saveDMCAnswers = (data:any):any => {
  return {type:DMC_ANS_DATA, payload:data}
}

export const removeAllDMCData = (data:any):any => {
  return {type:REMOVE_DMC_DATA, payload:data}
}

export const storeSORDAMP = (data:any):any => {
  return {type:STORE_SORDAMP, payload:data}
}

export const getSearchTypeCustomerData = (data:any):any => {
  return {type:SEARCH_TYPE_CUSTOMER, payload:data}
} 

export const getSearchTypeCustomerRemoveData = (data:any):any => {
  return {type:SEARCH_TYPE_CUSTOMER_REMOVE, payload:data}
} 

export const getSearchPropertyData = (data:any):any => {
  return {type:SEARCH_TYPE_PROPERTY, payload:data}
}

export const getSearchPropertyRemoveData = (data:any):any => {
  return {type:SEARCH_TYPE_PROPERTY_REMOVE, payload:data}
}

export const getSearchTypeWorkOrderData = (data:any):any => {
  return {type:SEARCH_TYPE_WORKORDER, payload:data}
}

export const getSearchTypeWorkOrderDataRemove = (data:any):any => {
  return {type:SEARCH_TYPE_WORKORDER_REMOVE, payload:data}
}

export const getSearchTypeServiceRequestData = (data:any):any => {
  return {type:SEARCH_TYPE_SERVICE_REQUEST, payload:data}
}

export const getSearchTypeServiceRequestDataRemove = (data:any):any => {
  return {type:SEARCH_TYPE_SERVICE_REQUEST_REMOVE, payload:data}
}

export const getSearchTypeSortData = (data:any): any => {
  return {type: SEARCH_TYPE_SORT_DATA, payload:data}
}

export const getSearchTypeSortDataRemove = (data:any): any => {
  return {type: SEARCH_TYPE_SORT_DATA_REMOVE, payload:data}
}

export const getCaseAssignToMeData = (data:any):any => {
  return {type:SEARCH_TYPE_ASSIGN_TO_ME_DATA, payload:data}
}
export const getCaseAssignToMeDataRemove = (data:any):any => {
  return {type:SEARCH_TYPE_ASSIGN_TO_ME_DATA_REMOVE, payload:data}
}
export const storeAPIErrors = (data: any): any => {
  return { type: API_ERRORS, payload: data };
}
export const saveDuplicateDMCAnswers = (data:any):any => {
  return {type:DUPLICATE_DMC_ANS_DATA, payload:data}
}
export const FinancialReferralDebtTypesRes = (payload: any): any => {
  return { type: REFERRAL_DEBT_TYPES, payload };
};
export const saveReferralReasonReferenceData = (data: any): any => {
  return {
    type: REFERRAL_REASON_REFERENCE_DATA,
    payload: data,
  };
};
export const saveNOSPReferenceData = (data: any): any => {
  return {
    type: NOSP_REFERENCE_DATA,
    payload: data,
  };
};
export const FinancialReferralNospDetailsRes = (payload: any): any => {
  return { type: REFERRAL_NOSP_DETAILS, payload };
};


export type NospResponsePayload = { id?: number; value: string };
export type NospDetailsPayloadItem = {
  questionId: number;
  label: string;
  responses: NospResponsePayload[];
};


export const saveNospDetailsPayload = (payload: NospDetailsPayloadItem[]) => ({
  type: SAVE_NOSP_DETAILS_PAYLOAD,
  payload,
});


export const saveIsHHSRSEnabledP360Toggle = (payload:any) => {
  return {type:IS_HHSRS_ENABLED, payload}
}

export const saveAssetSubTypeData = (payload:any) => {
  return {type:ASSET_SUBTYPE, payload}
}

export const saveParentAssetTypeData = (payload:any) => {
  return {type:PARENT_ASSET_TYPE, payload}
}